import React from "react";
import MatrixRain from "../components/MatrixRain";
import { Footer } from "../components/Sections";
import { usePageTracking } from "../analytics";
import {
  UrgencyBar,
  BrandHeader,
  FinancialQualifier,
  CompactOfferRow,
  ApplyFormV2,
  Testimonials,
  MINI_TESTIMONIALS,
  WhatHappensNext,
  StickyApplyBar,
} from "../components/FunnelV2Parts";

const ApplyV2Page = () => {
  usePageTracking("apply_v2");
  return (
    <div className="min-h-screen bg-[#050505] pb-24 sm:pb-20">
      <UrgencyBar />
      <div className="relative overflow-hidden">
        <div className="absolute inset-x-0 top-0 h-[280px] opacity-60">
          <MatrixRain />
          <div className="matrix-fade" />
        </div>
        <div className="relative z-10">
          <BrandHeader />
          <div className="space-y-12 pb-16 pt-2 sm:space-y-16">
            <FinancialQualifier />
            <CompactOfferRow />
            <div className="px-4">
              <ApplyFormV2 funnel="apply_v2" />
            </div>
            <Testimonials title="Real Traders. Real Results." items={MINI_TESTIMONIALS} />
            <WhatHappensNext />
          </div>
        </div>
      </div>
      <Footer />
      <StickyApplyBar />
    </div>
  );
};

export default ApplyV2Page;
